/* eslint-disable react-hooks/exhaustive-deps */
import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import useFileUpload from "react-use-file-upload";

import { AllowedFileExt } from "../config/app-constants";
import SvgImage from "./SvgImage";

type Props = {
  handleOnFileSelect: (selectedImages: File[]) => void;
  size?: "lg" | "";
  title?: string;
  hasError?: boolean;
  multiple?: boolean;
  allowedFileTypes?: string[];
};

const FileUploadDropzone: React.FC<Props> = (props: Props) => {
  const { files, handleDragDropEvent, setFiles, clearAllFiles } = useFileUpload();

  const inputRef = useRef<HTMLInputElement>(null);

  const {
    handleOnFileSelect,
    size = "",
    hasError = false,
    multiple = false,
    title = "Drop your file here or Click to Select",
    allowedFileTypes = [...AllowedFileExt]
  } = props;

  useEffect(() => {
    if (files.length > 0) {
      handleOnFileSelect(files);
      clearAllFiles();
    }
  }, [files.length]);

  return (
    <>
      <Form.Group className="form-group eds-drag-upload-group" controlId="files">
        <>
          <div
            onDragEnter={(e: any) => handleDragDropEvent(e)}
            onDragOver={(e: any) => handleDragDropEvent(e)}
            onDrop={(e: any) => {
              handleDragDropEvent(e);
              setFiles(e, "a");
            }}
            className={classNames(
              "drop-area",
              "file-dropZone",
              hasError && "border-danger",
              !size && "small-area"
            )}
            role="button"
            onClick={() => inputRef?.current?.click()}
          >
            <SvgImage imgId="file-upload-icon" />
            <div>
              <h5>{title}</h5>
              <p className={classNames("leading-para", "text-greyDark", size ? "mb-4" : "mb-0")}>
                If you already have the file, please upload it here. Supported file formats:&nbsp;
                {allowedFileTypes.join(", ")} Max File Size Should be 20MB
              </p>
              {size && (
                <Button variant="primary" size="sm" className="text-white">
                  Browse Files
                </Button>
              )}
            </div>
            <input
              ref={inputRef}
              type="file"
              multiple={multiple}
              accept={allowedFileTypes.join(", ")}
              style={{ display: "none" }}
              onChange={(e: any) => {
                setFiles(e, "a");
                if (inputRef?.current) {
                  inputRef.current.value = "";
                }
              }}
            />
          </div>
        </>
      </Form.Group>
    </>
  );
};

export default FileUploadDropzone;
